import { Route } from "react-router-dom";

import { CRM_VIEW_ALL_LEAD, CRM_VIEW_ASSIGNED_LEAD } from "src/constants";
import { CRM_ROUTES } from "src/pages/crm/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { Leads } from "./Leads.page";
import { SingleLead } from "./SingleLead.page";

const viewLeadPermissions = [CRM_VIEW_ALL_LEAD, CRM_VIEW_ASSIGNED_LEAD];

/** Route tree for the legacy CRM module, mounted under `/crm`. */
export const crmRoutes = (
  <>
    <Route path={CRM_ROUTES.root} element={<ProtectedRoute permissions={viewLeadPermissions} component={Leads} />} />
    <Route
      path={CRM_ROUTES.leadDetails}
      element={<ProtectedRoute permissions={viewLeadPermissions} logic="OR" component={SingleLead} />}
    />
  </>
);
